import { AddColumnLeftIcon, AddColumnRightIcon, Badge, Button, Card, EditIcon, EyeOpenIcon, Heading, Pane, Switch, Text, toaster } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import Request from "../../../util/Api";


export default function ProductCard(props) {
    const transferStock = async (source, target) => {
        try {
            await Request.post(`/inventory/transfer`, {}, {}, {
                source,
                target,
                quantity: 1,
                productId: props.product.id
            });


            props.onUpdate();

            toaster.success('Transfer efectuat cu succes!');
        } catch (e) {
            toaster.danger(e.message);
        }
    }


    return (
        <Card cursor="pointer">

            <Pane
                width="300px"
                height={props.editMode ? "450px" : "400px"}
                display="flex" flexDirection="column" justifyContent="space-between" alignItems="center"
                border="default" elevation={1} margin={16} padding={16}>
                <Pane>
                <img style={{height: '200px', width: 'auto'}} alt="product-thumbnail"
                            src={props.product.images[0] ?
                                process.env.REACT_APP_PRODUCT_IMAGE_BUCKET + '/thumb_' + props.product.images[0].image + '.webp' : null}/>
                </Pane>
                <Heading size={500}>
                    <Text color="orange" fontWeight="bold">#{props.product.id}</Text> {props.product.title}
                </Heading>
                <Pane display="flex" flex-direction="row" alignItems="center">
                    <Text color={props.product.oldPrice !== props.product.price ? "red" : ""} fontWeight="bold">
                        {props.product.price} Lei
                    </Text>
                    {props.product.oldPrice && props.product.oldPrice !== props.product.price ? <Text marginLeft={10} textDecoration="line-through">{props.product.oldPrice} Lei</Text> : null}

                    {/* <Badge marginLeft={10} color={props.product.score > 0 ? "green": "red"}>
                        Scor: {props.product.score || 0}
                    </Badge> */}

                    <Badge marginLeft={10} color={props.product.quantity > 0 ? "green": "red"} display="flex">
                        {Object.values(props.product.quantitySummary).map((qty, index) => {
                            return Object.keys(props.product.quantitySummary)[index] + ': ' + qty + ' ';
                        })}
                        {Object.values(props.product.quantitySummary).length === 0 ? '0' : ''}
                    </Badge>
                    <Badge marginLeft={10} color={props.product.quantity > 0 ? "green": "red"} display="flex">
                        <EyeOpenIcon/> {props.product.views || 0}
                    </Badge>
                </Pane>
                <Pane display="flex">
                    <Link to={`/products/${props.product.id}`}>
                        <Button marginY={8} marginRight={12}>
                            <EyeOpenIcon />
                        </Button>
                    </Link>

                    <Link to={`/products/${props.product.id}/edit`}>
                        <Button marginY={8} marginRight={12}>
                            <EditIcon/>
                        </Button>
                    </Link>


                    <Switch marginTop={13} height={24} checked={props.product.activeOnline} onChange={props.toggleProduct}/>
                </Pane>
                {props.editMode &&
                    <Pane display="flex">
                        <Button marginY={8} marginRight={12} onClick={() => transferStock(1, 4)}>
                            <AddColumnLeftIcon marginRight={10}/> Brasov - {props.product.quantitySummary['BV'] || 0}
                            {props.outstandingQuantities.find(qty => qty.stockAccountId === 4) ? ` (${props.outstandingQuantities.find(qty => qty.stockAccountId === 4).quantity})` : ''}
                        </Button>
                        <Button marginY={8} marginRight={12} onClick={() => transferStock(4, 1)}>
                        Ploiesti - {props.product.quantitySummary['PL'] || 0}
                        {props.outstandingQuantities.find(qty => qty.stockAccountId === 1) ? ` (${props.outstandingQuantities.find(qty => qty.stockAccountId === 1).quantity})` : ''}
                            <AddColumnRightIcon marginLeft={10}/>
                        </Button>
                    </Pane>}
            </Pane>
        </Card>
    )
}
